import { Toaster as Sonner, toast } from "sonner"

/**
 * Toaster global de l'application, accordé à la charte éditoriale Solunary
 * (surface crème `eh-cream`, filet `eh-border-soft`, encre `eh-ink`, rayon 2xl —
 * mêmes jetons que les cartes de l'admin, cf. BookingsAdmin.jsx).
 *
 * Le style par défaut de sonner est une boîte grise indifférenciée : une ERREUR y
 * ressemblait à une confirmation, alors que le seul signal utile d'un toast est
 * « est-ce que mon action a réussi ? ». D'où un liseré de couleur porteur de sens
 * (rouge = échec, sauge = succès, ocre = avertissement) : la couleur est REDONDANTE
 * avec le texte et l'icône, jamais le seul véhicule de l'information (a11y).
 *
 * `theme="light"` est explicite : aucun ThemeProvider next-themes n'est monté dans
 * l'app, donc le "system" d'origine laissait le rendu dépendre du thème de l'OS —
 * un toast crème sur fond crème pouvait devenir illisible en mode sombre.
 */
const Toaster = ({ ...props }) => {
  return (
    <Sonner
      theme="light"
      position="bottom-right"
      closeButton
      duration={5000}
      className="toaster group"
      toastOptions={{
        classNames: {
          toast:
            "group toast !bg-eh-cream !text-eh-ink !border !border-eh-border-soft " +
            "!rounded-2xl !shadow-[0_8px_30px_rgba(44,53,49,0.12)] !gap-3 !p-4 " +
            "!border-l-4 !font-sol-body",
          title: "!font-sol !text-[0.9rem] !font-medium !leading-snug",
          description: "!text-eh-muted !text-xs !leading-relaxed",
          icon: "!mt-0.5",
          closeButton:
            "!bg-eh-cream !border-eh-border-soft !text-eh-muted hover:!text-eh-ink",
          actionButton: "!bg-eh-ink !text-eh-cream !rounded-full !px-3 !text-xs",
          cancelButton:
            "!bg-transparent !text-eh-muted !rounded-full !px-3 !text-xs",
          error: "!border-l-red-500 [&_[data-icon]]:!text-red-600",
          success: "!border-l-eh-sage-deep [&_[data-icon]]:!text-eh-sage-deep",
          warning: "!border-l-eh-ochre [&_[data-icon]]:!text-eh-ochre-deep",
          info: "!border-l-eh-sage [&_[data-icon]]:!text-eh-sage-deep",
        },
      }}
      {...props}
    />
  );
}

export { Toaster, toast }
